<template>
  <div>
    <keep-alive>
      <router-view />
    </keep-alive>
    <div class="fullwidth darker">
      <style-browser animation />
    </div>
  </div>
</template>

<script>
import StyleBrowser from '@/components/panels/StyleBrowser.vue'

export default {
  components: {
    StyleBrowser
  }
}
</script>

<style>

</style>